// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimpleContent_wrapper__XaYIH"};